import * as SecureStore from 'expo-secure-store'

export const getItemAsync = SecureStore.getItemAsync
